<template>
  <div class="fixed-plugin isis-fab" v-click-outside="closeDropDown">
    <div class="dropdown show-dropdown" :class="{ show: isOpen }">
      <a data-toggle="dropdown">
        <i class="fas fa-2x" :class="icon" @click="toggleDropDown"> </i>
      </a>
      <ul class="dropdown-menu px-0 pb-2" :class="{ show: isOpen }">
        <p
          class="text-gray-600 capitalize text-base text-center font-medium py-2"
        >
          {{ title }}
        </p>

        <slot name="dropdown-menu-content">
          <li class="adjustments-line">Line 1</li>
          <li class="adjustments-line">Line 2</li>
          <li class="adjustments-line">Line 3</li>
        </slot>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "isis-fab",
  props: {
    title: {
      type: String,
      default: "Dropwdown Menu Title"
    },
    icon: {
      type: String,
      default: "fa-tasks"
    },
    shouldHiddenSettingIcon: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    toggleDropDown() {
      this.isOpen = !this.isOpen;
    },
    closeDropDown() {
      this.isOpen = false;
    },
    hiddenSettingIcon() {
      document.querySelector(".fixed-plugin:not(.isis-fab)").style.display =
        "none";
    },
    showSettingIcon() {
      document.querySelector(".fixed-plugin:not(.isis-fab)").style.display =
        "block";
    }
  },

  mounted() {
    if (this.shouldHiddenSettingIcon) {
      this.hiddenSettingIcon();
    }
  },
  beforeDestroy() {
    if (this.shouldHiddenSettingIcon) {
      this.showSettingIcon();
    }
  }
};
</script>
<style lang="scss" scoped>
.isis-fab {
  .dropdown-menu {
    .header-title {
    }
  }

  .dropdown {
    a > i {
      color: #ffffff;
      padding: 10px;
      border-radius: 0 0 6px 6px;
      width: auto;
    }
  }
}
</style>
